import { Component, OnInit, Inject } from "@angular/core";
import { EmployeeService } from "../../service/employee.service";
import { ToastrService } from "ngx-toastr";
import { UserService } from "../../service/user.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { OnboardingService } from "../../service/onboarding.service";
import { JobSource } from "../../models/JobSource";
import { JobPlatform } from "../../models/JobPlatform";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";

@Component({
  selector: "app-profilesource-dialog",
  templateUrl: "./profilesource-dialog.component.html",
  styleUrls: ["./profilesource-dialog.component.css"],
})
export class ProfilesourceDialogComponent implements OnInit {
  title: string;
  message: any;
  error: any;
  empCode: number;
  ProfileForm: FormGroup;
  jobSourcesList: any[];
  jobPlatformsList: any[] = [];
  nameExists: Boolean = false;
  jobSource: JobSource;
  jobPlatform: JobPlatform;
  Name: string;
  JobPlatform: string;
  disableButton: Boolean = false;
  JobPlatformNameExists: Boolean = false;
  jobSourceId_bkp: number;
  constructor(
    private toastr: ToastrService,
    private userService: UserService,
    public dialogRef: MatDialogRef<ProfilesourceDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ProfilesourceDialog,
    private _service: EmployeeService,
    private formBuilder: FormBuilder,
    private hrSvc: OnboardingService
  ) {
    dialogRef.disableClose = true;
    // Update view with given values
    this.title = data.title;
    this.message = data.message;
  }

  ngOnInit() {
    this.jobSource = new JobSource();
    this.jobPlatform = new JobPlatform();
    this.empCode = this.userService.getEmpCode();
    this.jobSourceId_bkp = this.data.jobSourceId;
    if (this.data.type == "jobSource") {
      this.getJobSources();
    } else {
      this.getJobSources();
      setTimeout(() => {
        this.getJobPlatform(this.data.jobSourceId);
      }, 500);
    }
    const nonWhitespaceRegExp: RegExp = new RegExp("\\S");
    if (this.data.type == "jobSource") {
      this.ProfileForm = this.formBuilder.group({
        Name: [
          "",
          [Validators.required, Validators.pattern(nonWhitespaceRegExp)],
        ],
        JobPlatform: [
          "",
          [Validators.pattern(nonWhitespaceRegExp)]
        ],
      });
    } else {
      this.ProfileForm = this.formBuilder.group({
        Name: [
          "",
          [Validators.required, Validators.pattern(nonWhitespaceRegExp)],
        ],
      });
    }
  }

  getJobSources() {
    this.hrSvc.getJobSources().subscribe((data: any) => {
      this.jobSourcesList = data;
    });
  }

  getJobPlatform(Id) {
    const selectedId =
      this.jobSourcesList.find(({ Name }) => Name === Id).Id || Id;
    this.hrSvc.getJobPlatforms(selectedId).subscribe((data: any) => {
      this.jobPlatformsList = data;
    });
  }

  get f() {
    return this.ProfileForm.controls;
  }

  onConfirmJobPlatform(Name): void {
    this.getJobSources();
    if (!this.ProfileForm.invalid) {
      this.jobPlatformsList.map((item) => {
        if (item.Name != null && item.Name.toLowerCase() == Name.toLowerCase()) {
          this.nameExists = true;
        }
      });

      if (this.nameExists == true) {
        this.toastr.warning("Same Sub-Category exists");
        this.jobPlatform.Name = null;
        this.nameExists = false;
      }

      this.jobPlatform.Name = Name;
      this.jobPlatform.ModifiedBy = this.empCode.toString();
      this.jobPlatform.CreatedBy = this.empCode.toString();

      const selectedId = this.jobSourcesList.find(
        ({ Name }) => Name === this.data.jobSourceId
      ).Id;
      this.jobPlatform.ProfileSourceId = selectedId;
      if (this.nameExists == false) {
        this.hrSvc.SaveJobPlatform(this.jobPlatform).subscribe(
          (data) => {
           // console.log("=====1=====");
            this.dialogRef.close(this.jobPlatform);
          },
          (error) => (this.error = error)
        );
      }
    } else {
      return;
    }
  }

  onConfirm(Name, JobPlatform): void {
    if (!this.ProfileForm.invalid) {
      if (this.data.type == "jobSource") {
        this.jobSource.Name = Name;
        this.jobSource.JobPlatform = JobPlatform;
        this.jobSource.ModifiedBy = this.empCode.toString();
        this.jobSource.CreatedBy = this.empCode.toString();
        this.jobSourcesList.forEach((item) => {
          if (item.Name.toLowerCase() == this.jobSource.Name.toLowerCase()) {
            this.nameExists = true;
          }
        });

        this.jobPlatformsList.map((item) => {
          if (
            item.Name.toLowerCase() == this.jobSource.JobPlatform.toLowerCase()
          ) {
            this.JobPlatformNameExists = true;
          }
        });

        if (this.nameExists == false && this.JobPlatformNameExists == false) {
          this.hrSvc.SaveJobSource(this.jobSource).subscribe(
            (data) => {
              this.disableButton = true;
              this.getJobSources();
              setTimeout(() => {
                const selectedId = this.jobSourcesList.find(
                  ({ Name }) => Name === this.Name || Name
                ).Id;
                this.hrSvc
                  .getJobPlatforms(selectedId)
                  .subscribe((data: any) => {
                    this.jobPlatformsList = data;
                  });
                this.dialogRef.close(this.jobSource);
                this.disableButton = false;
              }, 500);
            },
            (error) => (this.error = error)
          );
        } else {
          if (this.JobPlatformNameExists == true) {
            this.toastr.warning("Same Sub-category exists");
            this.jobSource.JobPlatform = null;
            this.JobPlatformNameExists = false;
          } else {
            this.toastr.warning("Same Job source exists");
            this.jobSource.Name = null;
            this.nameExists = false;
          }
        }
      }
    } else {
      return;
    }
  }

  onDismiss(): void {
    // Close the dialog, return false
    this.dialogRef.close(false);
  }
}

export class ProfilesourceDialog {
  constructor(
    public type: string,
    public title: string,
    public message: any,
    public jobSourceId: number
  ) {}
}
